var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgErrorCircleOutline24 = props => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.93 4.93a9.97 9.97 0 0 1 14.14 0 9.97 9.97 0 0 1 0 14.14 9.97 9.97 0 0 1-14.14 0 9.97 9.97 0 0 1 0-14.14ZM12 3.8A8.17 8.17 0 0 0 3.8 12a8.17 8.17 0 0 0 8.2 8.2 8.17 8.17 0 0 0 8.2-8.2A8.17 8.17 0 0 0 12 3.8Z",
  fill: "currentColor"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M13 16a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z",
  fill: "currentColor"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 7c.5 0 .9.4.9.9v5.2a.9.9 0 0 1-1.8 0V7.9c0-.5.4-.9.9-.9Z",
  fill: "currentColor"
})));
export { SvgErrorCircleOutline24 as ReactComponent };